<template>
  <div class="" style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>Warehouse: {{this.wh.name}}</h1>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn v-if="isAllowed('warehouse','u')" @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-form :disabled="!isEditable">
        <v-row>
          <v-col>
            <v-text-field
                label="Name"
                outlined
                v-model="wh.name"
            ></v-text-field>
            <v-text-field
                label="Address"
                outlined
                v-model="wh.address"
            ></v-text-field>
            <v-text-field
                label="Description"
                outlined
                v-model="wh.description"
            ></v-text-field>
            <v-select
                label="Branch"
                outlined
                :items="branches"
                item-text="name"
                item-value="id"
                v-model="wh.branchId"
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col v-if="isEditable">
          <v-btn @click="updateWh">Save</v-btn>
          <v-btn v-if="isAllowed('warehouse','d')" style="margin-left: 10px;" class="error" @click="deleteWh">Delete</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <hr>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row align-center">
                <h1>Rooms</h1>
                <v-progress-circular
                    indeterminate
                    color="green"
                    v-if="loader"
                    style="margin-left: 10px;"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                    :headers="roomHeaders"
                    :items="wh.Rooms"
                    :items-per-page="-1"
                    class="elevation-1"
                    @click:row="roomRowClick"
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col v-if="isAllowed('room','c')" cols="4">
          <v-container>
            <v-row>
              <v-col class='d-flex flex-row align-center'>
                <h1>Add New Room</h1>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    label="Name"
                    outlined
                    v-model="room.name"
                ></v-text-field>
                <v-text-field
                    label="Description"
                    outlined
                    v-model="room.description"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn @click="createRoom" :disabled="!this.room.name">Create</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        max25chars: v => v.length <= 25 || 'Input too long!',
        roomHeaders: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: "Description", value: 'description'}
        ],

        branches: [],

        editMode: false,
        wh: {},
        room: {},
        isEditable: false,
      }
    },
    async mounted(){
        await this.getAllData();
    },
    computed: {
      ...mapGetters(['getEndpoint', "isAllowed"])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      async updateWh(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/warehouses/${this.$route.params.id}`, this.wh)
          if(res.data.error) throw res.data.error

          if(res.data.success){
            this.snack(`Warehouse Updated 🎉`, "success");
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async deleteWh(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/warehouses/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error

          this.snack(`Warehouse Deleted 🎉`, "success");
          await this.$router.push({path: "/warehouses"});
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      roomRowClick(room){
        this.$router.push({ path: `/warehouses/view/${this.wh.id}/rooms/view/${room.id}`})
      },
      async createRoom(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/rooms`, this.room)
          if(res.data.error) throw res.data.error

          this.snack(`Room Created 🎉`, "success");
          this.room={};
          await this.getAllData();
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        }
      },
      async getAllData(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/warehouses/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          this.wh = res.data.data
          this.room.warehouseId=this.wh.id;

          let branches = await axios.get(`${this.getEndpoint}/api/branches`)
          if(branches.data.error) throw branches.data.error
          this.branches = branches.data.data;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      }
    }
  }
</script>
